// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"uO-z","carouselContainer":"vO-z"};